'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @flow
var careers = exports.careers = {
  title: 'Prepárate para la carrera de tu vida',
  description: 'Aprende lo que siempre has soñado y accede al empleo que te habría gustado tener. Ya no hay nada que te lo impida',
  background_url: 'https://dev-res.thumbr.io/images/careers-banner.jpg',
  view_careers: 'Ver Carreras',
  how_it_works_title: '¿Cómo funcionan las Carreras?',
  how_it_works_description: 'Eliges una Carrera, contratas un Plan y a empezar',
  how_it_works: JSON.stringify(['find_a_career', 'subscribe', 'learn', 'certificates']),
  hiw_find_a_career: 'Encuentra tu Carrera',
  hiw_find_a_career_explained: '¿Qué te inspira? encuentra tu Carrera, podrás hacer las que quieras.',
  hiw_find_a_career_icon: 'https://lib.tutellus.com/images/icons/find.svg',

  hiw_subscribe: 'Contrata un Plan',
  hiw_subscribe_explained: 'Escoge el plan que mejor se adapte a ti. De mensual a anual.',
  hiw_subscribe_icon: 'https://lib.tutellus.com/images/icons/infinite-yellow.svg',
  hiw_learn: 'Accede a los cursos',
  hiw_learn_explained: 'Empieza tu Ruta Formativa y completa tu Carrera a tu propio ritmo.',
  hiw_learn_icon: 'https://lib.tutellus.com/images/icons/teach-orange.svg',
  hiw_certificates: 'Certifica tu Formación',
  hiw_certificates_explained: 'Consigue un reconocimiento de los Cursos y Carrera. ¡Te lo has ganado!',
  hiw_certificates_icon: 'https://lib.tutellus.com/images/icons/certified.svg',
  find_a_career: 'Encuentra tu Carrera ideal',
  view_less: 'Ver menos',
  view_all: 'Ver todas',
  select_a_plan_title: 'Selecciona un plan para tu Carrera',
  select_a_plan_description: 'Contrata el plan que mejor se adapte a ti. Podrás pararlo o cancelarlo cuando quieras',
  faq: 'Preguntas frecuentes',
  faqs: JSON.stringify([{ q: '¿Qué aprenderé estudiando una Carrera?',
    a: 'Las Carreras te ayudarán a convertirte en un profesional de la temática que elijas. Con una Carrera de Tutellus te convertirás en lo que siempre has querido ser, pudiendo trabajar en lo que te apasiona.' }, { q: '¿Puedo matricularme en cualquier Carrera?',
    a: 'Si. No importa el nivel de conocimientos que tengas ni tus estudios previos, cualquier Carrera empieza de cero y llega hasta niveles avanzados. Te aconsejamos que empieces por la Carrera que más te motive, y cuando la termines te apuntes en la siguiente.' }, { q: '¿Qué Beneficios añadidos me da una Carrera?',
    a: 'Además de tener una Ruta Formativa única y planificada, cualquier Carrera dispone de un Tutor personal, una persona que te ayudará y mentorizará durante todo el camino. Además, tendrás el apoyo de la comunidad y de todos los profesores que participan en la Carrera.' }, { q: '¿Cómo contrato una Carrera?',
    a: 'Las Carreras se contratan a través de la Suscripción. Elije el plan que mejor te encaje (te recomendamos el anual, ya que es el más barato) y empieza a cambiar tu vida hoy.' }, { q: '¿Cuánto tiempo tengo que contratar una Carrera?',
    a: 'El tiempo que quieras. Lo mínimo es 1 mes, aunque por la duración de la Carrera lo normal es que tardes varios meses en terminar cada una. De cualquier forma puedes dejar tu Carrera "a medias" y retomarla en un futuro, cuando quieras.' }]),
  courses: 'cursos'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/careers.js
// module id = 694
// module chunks = 0